export default __webpack_public_path__ + "static/media/arrow_icon_blue.50c49eb5.svg";